<h1 class="u-sr-only">{{ 'TherapyFundWallet.Title' | translate }}</h1>
<section class="c-section c-section--first c-section--last c-section--open c-section--static u-no-pb">
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{ 'TherapyFundWallet.Title' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<card-therapy-fund-wallets></card-therapy-fund-wallets>
			</div>
		</div>
	</div>
</section>
